/**
 * KAN-988: функции тарифа кабинета из /auth/me (поле features) под общим
 * ключом ['currentUser'], тем же запросом, что api_access. Пока ответа нет,
 * функция выключена; ответ из кеша используется с первого рендера.
 */
import { useCurrentUser } from '@/hooks/useCurrentUser';

const NO_FEATURES: string[] = [];

export function useFeatures(): string[] {
  // Без деструктуризации: тесты маршрутов App подменяют useQuery пустым моком.
  return useCurrentUser()?.data?.features ?? NO_FEATURES;
}

export function useFeature(code: string): boolean {
  return useFeatures().includes(code);
}
